function setMultiSelects() {
  const multiSelects = document.querySelectorAll('.custom-multiselect');

  if(multiSelects) {
    console.log('there is at least one multiselect');
    multiSelects.forEach( (multiselect)=> {
      const selectTrigger = multiselect.querySelector('.gfield_description:not(.validation_message)');
      const selectOptions = multiselect.querySelector('.ginput_container_checkbox');
      const wrapper = document.createElement('div');
      wrapper.classList.add('custom-multiselect__wrapper');

      selectTrigger.parentNode.insertBefore(wrapper,selectTrigger);

      wrapper.appendChild(selectTrigger);
      wrapper.appendChild(selectOptions);

      const defaultTriggerTxt = selectTrigger.textContent;

      let isVisible = false;

      function updateChoices() {
        const choices = [];
        const selectedOptions = selectOptions.querySelectorAll('input:checked');
        if (selectedOptions) {
          selectedOptions.forEach( (option) => {
            const thisVal = option.getAttribute('value');
            choices.push(thisVal);
            // console.table(choices);
          });

          if(choices.length > 0) {
            const choicesString = choices.join(', ');
            selectTrigger.textContent = choicesString;
          } else {
            selectTrigger.textContent = defaultTriggerTxt;
          }
        }
      }

      function toggleWrapper() {
        wrapper.classList.toggle('is-open');
        isVisible = !isVisible;
        updateChoices();
      }

      selectTrigger.addEventListener('click', (e)=> {
        e.preventDefault;
        toggleWrapper();
      });

      document.addEventListener('click', ()=> {
        if (!wrapper.contains(event.target) && isVisible) {
          toggleWrapper();
        }
      });

    });
  }
}
setMultiSelects();

jQuery(document).on('gform_post_render', function(){
  setMultiSelects();
});



// WEBPACK FOOTER //
// ./scripts/util/multiSelect.js